/* SIELA language switcher: progressive enhancement for snippets/siela-language-switcher.liquid.
   Without JS the links still work. Bound once per page. */
(function () {
  if (window.__sielaLangInit) return;
  window.__sielaLangInit = true;

  /* Handles are translated per language, so a rebuilt path can 404.
     Shopify prints the correct URL per language as hreflang alternates. */
  function upgradeLinks() {
    var map = {};
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(function (l) {
      map[l.hreflang.toLowerCase()] = l.href;
    });
    if (!Object.keys(map).length) return;
    document.querySelectorAll('[data-siela-lang]').forEach(function (a) {
      var code = a.getAttribute('data-siela-lang');
      var href = map[code] || map[code.split('-')[0]];
      if (href) a.setAttribute('href', href);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', upgradeLinks);
  else upgradeLinks();

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-siela-lang]');
    if (link) {
      /* an explicit choice outranks detection for a year */
      document.cookie = 'siela_locale=' + link.getAttribute('data-siela-lang-token') +
        '; path=/; expires=' + new Date(Date.now() + 31536000000).toUTCString() + '; SameSite=Lax';
    }
    document.querySelectorAll('[data-siela-lang-menu][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-siela-lang-menu][open]').forEach(function (d) {
      d.open = false;
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });
})();
